module.exports = __webpack_public_path__ + "media/svg-new/next-ed4ce57b.svg";